<template>
  <div v-if="show" class="update-firebase-results-modal">
    <div class="update-firebase-results-modal__overlay" @click="$emit('close')"></div>

    <div class="update-firebase-results-modal__modal">
      <div class="header">
        <button class="close-btn" @click="$emit('close')">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12M4 4L12 12" stroke="#666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="content-modal">
        <div class="icon-container">
          <svg v-if="results.success && results.errorCount === 0" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-success">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <polyline points="22 4 12 14.01 9 11.01" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-warning">
            <circle cx="12" cy="12" r="10" stroke="#f59e0b" stroke-width="2"/>
            <path d="M12 8v4M12 16h.01" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <h2 class="modal-title">{{ results.success && results.errorCount === 0 ? 'Update Completed' : 'Update Completed with Warnings' }}</h2>
        
        <div class="stats-container">
          <div class="stat-item stat-success">
            <div class="stat-value">{{ results.updatedCount || 0 }}</div>
            <div class="stat-label">Updated</div>
          </div>
          <div class="stat-item stat-skipped">
            <div class="stat-value">{{ results.skippedCount || 0 }}</div>
            <div class="stat-label">Skipped</div>
          </div>
          <div class="stat-item" :class="results.errorCount > 0 ? 'stat-error' : 'stat-neutral'">
            <div class="stat-value">{{ results.errorCount || 0 }}</div>
            <div class="stat-label">Errors</div>
          </div>
        </div>

        <div v-if="results.errors && results.errors.length > 0" class="errors-container">
          <div class="errors-title">Error Details:</div>
          <div class="errors-list">
            <div v-for="(error, index) in results.errors.slice(0, 5)" :key="index" class="error-item">
              {{ error }}
            </div>
            <div v-if="results.errors.length > 5" class="error-more">
              ... and {{ results.errors.length - 5 }} more errors
            </div>
          </div>
        </div>

        <div class="button-container">
          <button 
            type="button" 
            class="btn btn--primary" 
            @click="$emit('close')"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateFromFirebaseResultsModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    results: {
      type: Object,
      default: () => ({
        success: false,
        updatedCount: 0,
        skippedCount: 0,
        errorCount: 0,
        errors: []
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .update-firebase-results-modal
    &__overlay
      position fixed
      top 0
      left 0
      right 0
      bottom 0
      background rgba(#000, 0.45)
      z-index 80000

    &__modal
      position fixed
      top 50%
      left 50%
      padding 30px
      transform translateX(-50%) translateY(-50%)
      width 500px
      max-width 90vw
      z-index 90000
      background #ffffff
      border-radius 8px
      box-shadow 0 4px 20px rgba(0, 0, 0, 0.15)

      .header
        position relative
        margin-bottom 10px

        .close-btn
          position absolute
          top 0
          right 0
          background none
          border none
          padding 0
          cursor pointer
          display flex
          align-items center
          justify-content center
          width 24px
          height 24px
          transition opacity 0.2s

          &:hover
            opacity 0.7

          svg
            display block

      .content-modal
        text-align center

        .icon-container
          margin-bottom 20px
          display flex
          justify-content center

          .icon
            &.icon-success
              color #10b981

            &.icon-warning
              color #f59e0b

        .modal-title
          font-size 24px
          font-weight 600
          color #333
          margin-bottom 24px

        .stats-container
          display flex
          justify-content space-around
          margin-bottom 24px
          padding 20px
          background-color #f8f9fa
          border-radius 8px

          .stat-item
            flex 1
            text-align center

            .stat-value
              font-size 32px
              font-weight 700
              margin-bottom 4px

            .stat-label
              font-size 14px
              color #666
              font-weight 500

            &.stat-success
              .stat-value
                color #10b981

            &.stat-skipped
              .stat-value
                color #6b7280

            &.stat-error
              .stat-value
                color #ef4444

            &.stat-neutral
              .stat-value
                color #6b7280

        .errors-container
          margin-bottom 24px
          padding 16px
          background-color #fef2f2
          border-radius 4px
          border 1px solid #fecaca
          text-align left

          .errors-title
            font-size 14px
            font-weight 600
            color #991b1b
            margin-bottom 8px

          .errors-list
            max-height 150px
            overflow-y auto

            .error-item
              font-size 12px
              color #7f1d1d
              padding 4px 0
              line-height 1.4

            .error-more
              font-size 12px
              color #991b1b
              font-style italic
              padding 4px 0
              margin-top 4px

        .button-container
          display flex
          justify-content center

          .btn
            min-width 120px
            padding 10px 20px
            border-radius 4px
            font-weight 500
            cursor pointer
            transition all 0.2s
            display flex
            align-items center
            justify-content center
            line-height 1
            height auto

            &.btn--primary
              background-color #423799
              color #fff
              border none

              &:hover
                background-color #352a7a
</style>























// WEBPACK FOOTER //
// UpdateFromFirebaseResultsModal.vue?69acf26c